module.exports = __webpack_public_path__ + "static/media/25-13.c54ca161.mp3";